/* SQINWEAR · Medición del final de cada página de colección (Google Analytics 4, eventos estándar):
   - Banner «Te ayudamos a elegir»: view_promotion (lo ha visto) y select_promotion (ha pinchado).
     GA4 › Informes › Monetización › Promociones.
   - Productos de la categoría complementaria: view_item_list (ha visto el bloque) y select_item (ha pinchado un producto).
     GA4 › Informes › Monetización › Compras de comercio electrónico (por lista de artículos). */
(function(){
  if (!document.body || !/template--collection/.test(document.body.className)) return;
  function send(name, params){ try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch(e){} }
  function once(el, fn){
    if (!el || !('IntersectionObserver' in window)) return;
    var done = false;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting && !done){ done = true; io.disconnect(); fn(); } });
    }, { threshold: 0.4 });
    io.observe(el);
  }

  function setup(){
    var root = document.querySelector('[data-sq-ce]');
    if (!root) return false;
    var from = root.getAttribute('data-from') || '';
    var to = root.getAttribute('data-to') || '';

    /* Banner del test */
    var quiz = root.querySelector('[data-sq-ce-quiz]');
    if (quiz){
      var promo = { promotion_id: 'test__' + from, promotion_name: 'Test · final de ' + from, creative_slot: 'final_coleccion', location_id: 'coleccion_' + from };
      once(quiz, function(){ send('view_promotion', { location_id: promo.location_id, items: [promo] }); });
      quiz.addEventListener('click', function(){ send('select_promotion', { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name, creative_slot: promo.creative_slot, location_id: promo.location_id, items: [promo] }); });
    }

    /* Productos complementarios */
    var box = root.querySelector('[data-sq-ce-products]');
    if (box){
      var listId = 'final_' + from;
      var listName = 'Final ' + from + ' → ' + to;
      var links = Array.prototype.slice.call(box.querySelectorAll('card-product a[href*="/products/"]'));
      var seenH = {}, items = [];
      links.forEach(function(a){
        var h = ((a.getAttribute('href') || '').match(/products\/([^\/?#]+)/) || [])[1];
        if (h && !seenH[h]){ seenH[h] = 1; items.push({ item_id: h, item_name: h, index: items.length, item_list_id: listId, item_list_name: listName }); }
      });
      once(box, function(){ send('view_item_list', { item_list_id: listId, item_list_name: listName, items: items }); });
      links.forEach(function(a){
        a.addEventListener('click', function(){
          var h = ((a.getAttribute('href') || '').match(/products\/([^\/?#]+)/) || [])[1];
          var it = items.filter(function(x){ return x.item_id === h; })[0] || { item_id: h, item_name: h };
          send('select_item', { item_list_id: listId, item_list_name: listName, items: [it] });
        });
      });
      var all = root.querySelector('[data-sq-ce-all]');
      if (all) all.addEventListener('click', function(){ send('select_promotion', { promotion_id: 'vertodo__' + from + '__' + to, promotion_name: 'Ver todo · ' + from + ' → ' + to, creative_slot: 'final_coleccion', location_id: 'coleccion_' + from }); });
    }
    return true;
  }
  /* El bloque de productos se ve en rejilla: se quita el carrusel exterior para que dentro de cada tarjeta se puedan pasar las fotos */
  function unslide(){
    var sw = document.querySelector('[data-sq-ce-products] .card-product-slider');
    if (sw && sw.swiper){ try { sw.swiper.destroy(true, true); } catch(e){} }
    if (sw) sw.style.touchAction = 'auto';
  }
  var u = 0, ut = setInterval(function(){ unslide(); if (++u > 24) clearInterval(ut); }, 250);
  window.addEventListener('load', unslide);
  /* Scroll infinito: cuando la clienta se acerca al final del listado, se pulsa sola el botón «Cargar más» del tema.
     El botón se queda como respaldo. Vuelve a funcionar tras filtrar u ordenar. */
  var busy = false;
  function more(){
    /* El tema cambia la dirección a «?page=2…» al cargar: se quita para que al recargar o volver se vea desde el principio */
    if (/[?&]page=/.test(location.search) && document.querySelector('collection-load-more')){
      try { var url = new URL(location.href); url.searchParams.delete('page'); history.replaceState(history.state, '', url.toString()); } catch(e){}
    }
    var w = document.querySelector('collection-load-more');
    if (!w || w.classList.contains('hidden')) return;
    var b = w.querySelector('.js-btn-load-more');
    if (!b || b.hasAttribute('disabled') || busy) return;
    if (w.getBoundingClientRect().top < window.innerHeight + 900){
      busy = true; b.click();
      setTimeout(function(){ busy = false; }, 600);
    }
  }
  window.addEventListener('scroll', more, { passive: true });
  setInterval(more, 800);
  if (!setup()){
    var n = 0, t = setInterval(function(){ if (setup() || ++n > 20) clearInterval(t); }, 500);
  }
})();
